export default __webpack_public_path__ + "img/eiLNRfYE.f392b4eb.svg";